export default "__VITE_ASSET__BRDbq7Tz__"